import { compareId } from './compareId';

const initialAddressValue = { value: '', label: '', id: '' };

export const findAddressById = (addresses, address_id) => addresses
  .find(({ id }) => compareId(id, address_id)) || initialAddressValue;
